/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DamageGroupFromJSON, DamageGroupToJSON, } from './';
export function CommonDamageDictionaryDtoFromJSON(json) {
    return CommonDamageDictionaryDtoFromJSONTyped(json, false);
}
export function CommonDamageDictionaryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'damageDictionaryId': !exists(json, 'damageDictionaryId') ? undefined : json['damageDictionaryId'],
        'group': !exists(json, 'group') ? undefined : DamageGroupFromJSON(json['group']),
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}
export function CommonDamageDictionaryDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'damageDictionaryId': value.damageDictionaryId,
        'group': DamageGroupToJSON(value.group),
        'name': value.name,
    };
}
